module.exports = __webpack_public_path__ + "assets/212c3af269d019b2a5dcbfe204fd8da0.mp3";